<template>
  <div>
    <q-layout view="hHh LpR fFf">
      <q-header elevated class="bg-accent text-white">
        <q-toolbar>
          <q-toolbar-title>
            <router-link
              v-if="accesoAdmin"
              tag="span"
              id="title"
              to="Presupuestos"
              >Tecnologías sin zanja</router-link
            >
            <span v-else>Tecnologías sin zanja</span>
          </q-toolbar-title>
          <div class="logo">
            <a href="https://www.veolia.es/hubgrade" target="_blank">
              <img src="@/assets/img/panel/hubgrade-blanco.svg" />
            </a>
          </div>
          <pre></pre>
          <q-item style="text-align: center"></q-item>
          {{ $store.getters["TSZ/userMail"] }}
          <pre></pre>
          <q-btn
            v-if="accesoAdmin"
            flat
            round
            dense
            icon="account_circle"
            to="logout"
          />
          <q-btn v-else flat round dense icon="account_circle" />
        </q-toolbar>
      </q-header>
      <br />
      <br />
      <br />
      <div ID="Div9" runat="server">
        <TSZ_Tipo_Usuario />
      </div>
    </q-layout>
  </div>
</template>
<script>
import { Cookies } from 'quasar';

import TSZ_Tipo_Usuario from '@/components/Usuarios/components/TSZ_Registro_Usuarios.vue';
import '@/components/Usuarios/assets/css/css_usuario_vue.css';

import {
  QTabs,
  QRouteTab,
  QLayout,
  QHeader,
  QFooter,
  QDrawer,
  QPageContainer,
  QToolbar,
  QToolbarTitle,
  QMenu,
  QDialog
} from 'quasar';

export default {
  computed: {
    accesoAdmin () {
      let isadmin = process.env.VUE_APP_ACCESO_ADMIN;

      if (isadmin == 1) {
        return true;
      } else {
        return false;
      }
    }
  },

  data: function () {
    return {};
  },
  components: {
    TSZ_Tipo_Usuario,
    QTabs,
    QRouteTab,
    QLayout,
    QHeader,
    QFooter,
    QDrawer,
    QPageContainer,
    QToolbar,
    QToolbarTitle,
    QMenu,
    QTabs,
    QDialog,
    QRouteTab
  }
};
</script>

<style lang="scss" scoped>
.logo {
  img {
    margin-top: 10px;
    max-width: 135px;
    padding: 0px 0 0 0;
    height: 40px;
    align-items: center;
  }
  i {
    padding: 18px 2% 0 5%;
  }
}
</style>
